export const knowledgeExamples = {
  "l4-vs-l7-load-balancing": {
    command: "ss -lntp | grep -E ':80|:3306'",
    normal: "LISTEN 0 511 0.0.0.0:80   0.0.0.0:* users:((\"nginx\",pid=1328,fd=6))\nLISTEN 0 151 127.0.0.1:3306 0.0.0.0:* users:((\"mysqld\",pid=945,fd=22))",
    abnormal: "LISTEN 0 151 127.0.0.1:3306 0.0.0.0:* users:((\"mysqld\",pid=945,fd=22))",
    normalExplain: "80 端口对所有地址监听，可作为 HTTP 七层入口；MySQL 只绑定本机，外部负载均衡无法直接连接。",
    abnormalExplain: "预期的 80 端口消失了。负载均衡即使健康，也找不到真正接收 HTTP 请求的入口。",
  },
  "tcp-handshake": {
    command: "ss -ant state established '( dport = :443 )'",
    normal: "Recv-Q Send-Q Local Address:Port Peer Address:Port\n0      0      10.0.0.8:52816  47.93.10.20:443",
    abnormal: "Recv-Q Send-Q Local Address:Port Peer Address:Port",
    normalExplain: "ESTABLISHED 说明三次握手已完成；两个队列都是 0，当前没有明显的数据堆积。",
    abnormalExplain: "没有已建立连接。可能没人访问，也可能 SYN 被安全组、路由或防火墙挡住，不能直接断言服务挂了。",
  },
  "tcp-vs-udp": {
    command: "ss -lntup | head",
    normal: "Netid State  Local Address:Port Process\nudp   UNCONN 127.0.0.53:53 users:((\"systemd-resolve\",pid=612))\ntcp   LISTEN 0.0.0.0:22     users:((\"sshd\",pid=801))",
    abnormal: "Netid State Local Address:Port Process\ntcp   LISTEN 0.0.0.0:22 users:((\"sshd\",pid=801))",
    normalExplain: "DNS 本地解析器使用 UDP 53，SSH 使用 TCP 22。同一台机器可以同时提供两类传输协议。",
    abnormalExplain: "UDP 53 监听消失，本机域名解析可能异常，但 SSH 的 TCP 连接仍可正常工作。",
  },
  "dns-resolution": {
    command: "dig +short azlinux.com",
    normal: "47.93.10.20",
    abnormal: ";; communications error to 127.0.0.53#53: timed out\n;; no servers could be reached",
    normalExplain: "解析器成功返回 A 记录。下一步仍要验证目标 IP 的端口和应用，而不是把“能解析”当成“网站正常”。",
    abnormalExplain: "请求连 DNS 服务器都没得到响应，应先检查 resolv.conf、解析服务和到 DNS 服务器的网络。",
  },
  "http-status-codes": {
    command: "curl -sS -o /dev/null -w '%{http_code} %{time_total}s\\n' http://127.0.0.1/health",
    normal: "200 0.012841s",
    abnormal: "502 3.001927s",
    normalExplain: "健康接口返回 200 且只用 12ms；这是比“进程存在”更接近业务健康的证据。",
    abnormalExplain: "502 且耗时约 3 秒，很像代理等待上游后失败。下一站应看 Nginx error.log 和 upstream。",
  },
  "reverse-proxy": {
    command: "curl -sSI -H 'Host: shop.example.com' http://127.0.0.1 | head",
    normal: "HTTP/1.1 200 OK\nServer: nginx\nX-Upstream: order-02",
    abnormal: "HTTP/1.1 502 Bad Gateway\nServer: nginx",
    normalExplain: "Host 命中了对应虚拟主机，并由 order-02 返回内容，反向代理链路完整。",
    abnormalExplain: "Nginx 自己活着，但 upstream 没给出有效响应；502 的重点通常在代理之后。",
  },
  "process-thread-service": {
    command: "systemctl status nginx --no-pager",
    normal: "● nginx.service - A high performance web server\n   Active: active (running) since Sat 2026-08-15 09:12:03 CST\n Main PID: 1328 (nginx)",
    abnormal: "× nginx.service - A high performance web server\n   Active: failed (Result: exit-code)\n  Process: 1328 ExecStartPre=/usr/sbin/nginx -t (code=exited, status=1/FAILURE)",
    normalExplain: "服务由 systemd 管理且主进程运行中，但还需要用 curl 验证真实请求。",
    abnormalExplain: "失败发生在启动前配置检查，别急着重启；先执行 nginx -t 获取具体文件和行号。",
  },
  "linux-load-average": {
    command: "uptime && vmstat 1 2 | tail -1",
    normal: "10:21:18 up 5 days, load average: 0.32, 0.41, 0.38\n 1  0 0 812344 0 923120 0 0 0 2 120 220 2 1 97 0 0",
    abnormal: "10:21:18 up 5 days, load average: 18.42, 15.10, 9.88\n 2 16 0 102144 0 923120 0 0 8240 91 180 350 3 2 40 55 0",
    normalExplain: "负载低、CPU idle 97%、IO wait 为 0，系统没有明显资源等待。",
    abnormalExplain: "高负载伴随大量阻塞任务和 55% IO wait，问题更像存储等待，不是简单缺 CPU。",
  },
  "memory-cache-swap": {
    command: "free -h",
    normal: "               total used free shared buff/cache available\nMem:           7.8Gi 3.1Gi 410Mi 82Mi 4.3Gi 4.2Gi\nSwap:          2.0Gi  12Mi 2.0Gi",
    abnormal: "               total used free shared buff/cache available\nMem:           7.8Gi 7.5Gi  80Mi 40Mi 220Mi 110Mi\nSwap:          2.0Gi 2.0Gi     0B",
    normalExplain: "free 很少但 available 仍有 4.2Gi，大量内存用于可回收缓存，这是健康现象。",
    abnormalExplain: "available 接近耗尽且 Swap 已满，继续增长可能触发抖动或 OOM Killer。",
  },
  "disk-space-vs-inode": {
    command: "df -h /var; df -i /var",
    normal: "/dev/vda1  40G  12G  26G  32% /\n/dev/vda1 2.6M 118K 2.5M 5% /",
    abnormal: "/dev/vda1  40G  18G  20G  48% /\n/dev/vda1 2.6M 2.6M    0 100% /",
    normalExplain: "数据空间和 inode 都充足。容量问题暂时不是首要嫌疑。",
    abnormalExplain: "磁盘还有 20G，却没有 inode；大量小文件一样会触发 No space left on device。",
  },
  "deleted-file-space": {
    command: "lsof +L1 | head",
    normal: "COMMAND PID USER FD TYPE DEVICE SIZE/OFF NLINK NAME",
    abnormal: "java 2841 sre  7w REG  253,1 12884901888 0 /var/log/order/app.log (deleted)",
    normalExplain: "只有表头，说明当前没有被进程持有的已删除文件。",
    abnormalExplain: "Java 仍握着一个已删除的 12GiB 日志；安全重开日志或重启该服务后空间才会真正释放。",
  },
  "systemd-troubleshooting": {
    command: "journalctl -u nginx -n 4 --no-pager",
    normal: "Started nginx.service - A high performance web server.\nConfiguration file /etc/nginx/nginx.conf test is successful",
    abnormal: "nginx[1328]: [emerg] unexpected '}' in /etc/nginx/conf.d/api.conf:18\nnginx.service: Control process exited, code=exited, status=1/FAILURE",
    normalExplain: "配置检查和启动都成功。若业务仍异常，应继续检查监听端口和 HTTP 请求。",
    abnormalExplain: "日志已经把根因定位到 api.conf 第 18 行，多按十次 restart 也不会修好这个右花括号。",
  },
  "time-wait": {
    command: "ss -s",
    normal: "TCP: 38 (estab 8, closed 21, orphaned 0, timewait 18)",
    abnormal: "TCP: 28742 (estab 116, closed 28580, orphaned 2, timewait 28113)",
    normalExplain: "少量 TIME_WAIT 是 TCP 正常收尾，不需要处理。",
    abnormalExplain: "TIME_WAIT 超过 2.8 万，先检查是否存在高频短连接、连接池失效或突发流量，再考虑参数。",
  },
  "database-primary-replica": {
    command: "mysql -e 'SHOW REPLICA STATUS\\G' | grep -E 'Running|Behind'",
    normal: "Replica_IO_Running: Yes\nReplica_SQL_Running: Yes\nSeconds_Behind_Source: 0",
    abnormal: "Replica_IO_Running: Yes\nReplica_SQL_Running: No\nSeconds_Behind_Source: NULL",
    normalExplain: "IO 与 SQL 线程都运行且延迟为 0，复制链路当前健康。",
    abnormalExplain: "还能接收日志，但 SQL 线程停止执行；应检查 Last_SQL_Error，不能只重启复制掩盖冲突。",
  },
  "mysql-slow-query": {
    command: "mysql -e 'SHOW FULL PROCESSLIST'",
    normal: "Id User Host db Command Time State Info\n18 sre localhost shop Sleep 2 NULL NULL",
    abnormal: "Id User Host db Command Time State Info\n91 app 10.0.0.8 shop Query 87 Sending data SELECT * FROM orders WHERE phone LIKE '%138%'",
    normalExplain: "当前只有短暂空闲连接，没有长期执行中的查询。",
    abnormalExplain: "查询已运行 87 秒，前置通配符通常难以利用普通索引；下一步用 EXPLAIN 看扫描行数。",
  },
  "redis-cache-failures": {
    command: "redis-cli INFO stats | grep -E 'keyspace_(hits|misses)'",
    normal: "keyspace_hits:982104\nkeyspace_misses:18422",
    abnormal: "keyspace_hits:12031\nkeyspace_misses:895102",
    normalExplain: "命中远高于未命中，缓存正在替数据库挡住大部分读取。",
    abnormalExplain: "未命中暴涨，可能发生穿透或大批键失效；此时数据库通常已经开始感受到压力。",
  },
  "message-backlog": {
    command: "rabbitmqctl list_queues name messages_ready messages_unacknowledged",
    normal: "name messages_ready messages_unacknowledged\norder.created 12 4",
    abnormal: "name messages_ready messages_unacknowledged\norder.created 184920 240",
    normalExplain: "只有少量待消费和处理中消息，生产消费速度基本平衡。",
    abnormalExplain: "18 万消息等待消费；先看消费者数量、错误日志和下游速度，别直接清空队列毁掉证据。",
  },
  "metrics-logs-traces": {
    command: "curl -s http://localhost:9090/api/v1/query?query=up | head -c 180",
    normal: "{\"status\":\"success\",\"data\":{\"result\":[{\"metric\":{\"job\":\"node\"},\"value\":[1786760400,\"1\"]}]}}",
    abnormal: "{\"status\":\"success\",\"data\":{\"result\":[{\"metric\":{\"job\":\"node\"},\"value\":[1786760400,\"0\"]}]}}",
    normalExplain: "Prometheus 查询成功，up=1 表示最近一次抓取目标成功。",
    abnormalExplain: "查询接口正常但目标 up=0；监控活着，被监控对象或采集网络出了问题。",
  },
  "sli-slo-sla": {
    command: "python3 -c 'print(f\"availability={99920/100000:.3%}\")'",
    normal: "availability=99.920%",
    abnormal: "availability=98.740%",
    normalExplain: "若本月 SLO 是 99.9%，当前仍高于目标，但错误预算已经消耗了一部分。",
    abnormalExplain: "若目标为 99.9%，98.74% 已明显违约；应停止只看服务器在线率，检查失败请求来源。",
  },
  "rto-rpo": {
    command: "printf 'failure=10:00 recovery=10:18 last_data=09:55\\n'",
    normal: "failure=10:00 recovery=10:04 last_data=09:59",
    abnormal: "failure=10:00 recovery=10:18 last_data=09:55",
    normalExplain: "本次 RTO 约 4 分钟、RPO 约 1 分钟；是否合格取决于业务预先定义的目标。",
    abnormalExplain: "恢复用了 18 分钟且可能丢 5 分钟数据；这才是容灾演练要量化的结果。",
  },
  "rolling-blue-green-canary": {
    command: "kubectl rollout status deployment/order --timeout=30s",
    normal: "deployment \"order\" successfully rolled out",
    abnormal: "Waiting for deployment \"order\" rollout to finish: 1 old replicas are pending termination...\nerror: timed out waiting for the condition",
    normalExplain: "新副本满足可用条件且旧副本完成退出，滚动发布结束。",
    abnormalExplain: "旧副本迟迟无法退出；应检查 Pod 状态、终止钩子、PDB 和新版本健康度。",
  },
  "kubernetes-pod-status": {
    command: "kubectl get pods",
    normal: "NAME                     READY STATUS  RESTARTS AGE\ngateway-7d9f8c4b6f-k2m8p 1/1   Running 0        8m",
    abnormal: "NAME                   READY STATUS             RESTARTS AGE\norder-6c88db8d5b-px9q2 0/1   CrashLoopBackOff   6        8m",
    normalExplain: "Running 且 READY 1/1，容器和就绪探针都通过；仍建议用真实接口做最终验证。",
    abnormalExplain: "容器已经重启 6 次并进入退避。用 logs --previous 查看上一次崩溃，而不是盯着它自动重启。",
  },
  "container-image-pull": {
    command: "kubectl describe pod order | tail -8",
    normal: "Normal Pulled  kubelet Successfully pulled image \"registry.local/order:v2\"\nNormal Started kubelet Started container order",
    abnormal: "Warning Failed kubelet Failed to pull image \"registry.local/order:v2\": unauthorized\nWarning Failed kubelet Error: ImagePullBackOff",
    normalExplain: "镜像拉取和容器启动均成功。接下来关注 readiness，而不是停在镜像阶段。",
    abnormalExplain: "错误明确是 unauthorized，应检查 imagePullSecret 和仓库权限；重建 Pod 不会让错误密码变正确。",
  },
  "backup-vs-disaster-recovery": {
    command: "ls -lh /backup/mysql && sha256sum -c /backup/mysql/latest.sha256",
    normal: "-rw------- 1 backup backup 2.4G Aug 15 02:00 full.sql.gz\nfull.sql.gz: OK",
    abnormal: "-rw------- 1 backup backup 12K Aug 15 02:00 full.sql.gz\nfull.sql.gz: FAILED\nsha256sum: WARNING: 1 computed checksum did NOT match",
    normalExplain: "文件存在且校验通过，但这仍只证明文件没损坏；还要定期执行恢复验证。",
    abnormalExplain: "12KB 的所谓全量备份且校验失败。任务显示“已完成”也不能把它变成可恢复的数据。",
  },
};
